import { ReactComponent as DropdownIcon } from '../../../../icons/dropdown.svg';

import { Select } from '../../select/Select';

export const RowActionsDropdown = ({ row, actions }) => {
  const handleSelect = (e) => {
    const action = actions.find((a) => a.value === e.target.value);
    if (action && typeof action.onSelect === 'function') {
      action.onSelect(row.original);
    }
  };

  return (
    <Select
      options={actions.map(({ label, value }) => ({ label, value }))}
      value=""
      onChange={handleSelect}
      placeholder="Actions"
      icon={DropdownIcon}
      showAsIcon
      dropdownWidth={100}
      filledIcon={false}
    />
  );
};
